import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Seo from "../components/common/seo";
import Socials from "../components/about/socials";

import INFO from "../data/user";

import "./styles/about.css";

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const aboutDescriptionLines = INFO.about.description.split("\n");
	const hasEmojiLine = aboutDescriptionLines.length > 1;
	const emojiLine = hasEmojiLine ? aboutDescriptionLines[0] : "";
	const descriptionLines = hasEmojiLine
		? aboutDescriptionLines.slice(1)
		: [INFO.about.description];

	return (
		<React.Fragment>
			<Seo page="about" />

			<div className="page-content">
				<NavBar active="about" />
				<div className="content-wrapper">
					<div className="about-logo-container">
						<div className="about-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="about-container">
						<div className="about-main">
							<div className="about-right-side">
								<div className="title about-title">
									{INFO.about.title}
								</div>

								<div className="subtitle about-subtitle">
									{hasEmojiLine ? (
										<React.Fragment>
											<span className="about-emoji-line">{emojiLine}</span>
											<span className="about-description-line">
												{descriptionLines.map((line, index) => (
													<React.Fragment key={`${index}-${line}`}>
														{index > 0 && <br />}
														{line}
													</React.Fragment>
												))}
											</span>
										</React.Fragment>
									) : (
										descriptionLines[0]
									)}
								</div>
							</div>

							<div className="about-left-side">
								<div className="about-image-container">
									<div className="about-image-wrapper">
										<img
											src="about.jpg"
											alt="about"
											className="about-image"
										/>
									</div>
								</div>

								<div className="about-socials">
									<Socials />
								</div>
							</div>
						</div>
						<div className="about-socials-mobile">
							<Socials />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default About;
